module.exports = __webpack_public_path__ + "static/img/jumping_jack.5c8a3bf8.png";